export default {
  translations: {}
}